import React, { Component } from 'react';

import TreeView from '@zippytech/react-toolkit/TreeView';
import uniqid from 'uniqid';

import MenuNode from './MenuNode';


const treeData = [
  {
    id: uniqid(),
    name: "phase 1",
    activities: [
      {
        id: uniqid(),
        name: "Prospecting"
      },
      {
        id: uniqid(),
        name: "Initial Consultation"
      },
    ]
  }, {
    id: uniqid(),
    name: "phase 2",
    activities: [
      {
        id: uniqid(),
        name: "Transaction Management"
      }
    ]
  }
]

class IntegrationTree extends Component {

  constructor(props) {
    super(props);
    this.state = {
      updateTime: new Date()
    }
  }

  handleAdd = (e, data) => {
    const addToDataNode = function (treeData, id) {
      treeData.forEach(function (treeNode) {
        if (treeNode.id === id) {
          if (!treeNode.activities) {
            treeNode.activities = [];
          }
          treeNode.activities.push(
            {
              id: uniqid(),
              name: "New Node"
            }
          )
        } else {
          if (treeNode.activities && treeNode.activities.length) {
            addToDataNode(treeNode.activities, id);
          }
        }
      });
    }
    addToDataNode(treeData, data.id);
    this.setState({
      updateTime: new Date()
    })
  }

  handlePeer = (e, data) => {

    const getParentNode = function (treeData, parentId, childId) {
      for (let index = 0; index < treeData.length; index++) {
        let treeNode = treeData[index];
        const currentNodeId = treeNode.id;
        if (currentNodeId.toString() === childId.toString()) {
          return { parentId, index }
        } else {
          if (treeNode.activities && treeNode.activities.length) {
            const result = getParentNode(treeNode.activities, currentNodeId, childId);
            if (result) {
              return result;
            }
          }
        }
      }
    }

    const addDataNodeToParent = function (treeData, parentId, dataNode) {
      if (parentId === "root") {
        treeData.push(dataNode);
      } else {
        treeData.forEach(function (treeNode) {
          if (treeNode.id === parentId) {
            treeNode.activities.push(dataNode);
          } else {
            if (treeNode.activities && treeNode.activities.length) {
              addDataNodeToParent(treeNode.activities, parentId, dataNode);
            }
          }
        });
      }
    }

    const targetNodeData = getParentNode(treeData, "root", data.id);

    const nodeToAdd = {
      id: uniqid(),
      name: "New Node"
    }

    addDataNodeToParent(treeData, targetNodeData.parentId, nodeToAdd);
    this.setState({
      updateTime: new Date()
    })
  }

  treeDnDAction = (sourceId, targetId) => {

    const getParentNode = function (treeData, parentId, childId) {
      for (let index = 0; index < treeData.length; index++) {
        let treeNode = treeData[index];
        const currentNodeId = treeNode.id;
        if (currentNodeId.toString() === childId.toString()) {
          return { parentId, index }
        } else {
          if (treeNode.activities && treeNode.activities.length) {
            const result = getParentNode(treeNode.activities, currentNodeId, childId);
            if (result) {
              return result;
            }
          }
        }
      }
    }

    const getDataNodeById = function (treeData, id) {
      for (let index = 0; index < treeData.length; index++) {
        let treeNode = treeData[index];
        const currentNodeId = treeNode.id;
        if (currentNodeId === id) {
          return Object.assign({}, treeNode);
        } else {
          if (treeNode.activities && treeNode.activities.length) {
            const result = getDataNodeById(treeNode.activities, id);
            if (result) {
              return result;
            }
          }
        }
      }
    }

    const addDataNodeToParent = function (treeData, parentId, dataNode, index) {
      if (parentId === "root") {
        treeData.push(dataNode);
      } else {
        treeData.forEach(function (treeNode) {
          if (treeNode.id === parentId) {
            treeNode.activities.splice(index, 0, dataNode);
          } else {
            if (treeNode.activities && treeNode.activities.length) {
              addDataNodeToParent(treeNode.activities, parentId, dataNode, index);
            }
          }
        });
      }
    }

    const deleteDataNodeById = function (treeData, id) {
      for (let i = treeData.length - 1; i >= 0; i--) {
        let treeNode = treeData[i];
        if (treeNode.id === id) {
          treeData.splice(i, 1);
          return;
        } else {
          if (treeNode.activities && treeNode.activities.length) {
            deleteDataNodeById(treeNode.activities, id);
          }
        }
      }
    }

    const targetNodeData = getParentNode(treeData, "root", targetId);

    const nodeCopy = getDataNodeById(treeData, sourceId);
    deleteDataNodeById(treeData, sourceId);
    addDataNodeToParent(treeData, targetNodeData.parentId, nodeCopy, targetNodeData.index);
    this.setState({
      updateTime: new Date()
    })

  }

  handleDelete = (e, data) => {
    const deleteDataNode = function (treeData, id) {
      for (let i = treeData.length - 1; i >= 0; i--) {
        let treeNode = treeData[i];
        if (treeNode.id === id) {
          treeData.splice(i, 1);
          return;
        } else {
          if (treeNode.activities && treeNode.activities.length) {
            deleteDataNode(treeNode.activities, id);
          }
        }
      }
    }
    deleteDataNode(treeData, data.id);
    this.setState({
      updateTime: new Date()
    })
  }

  dataChanged = (event, data) => {
    const updatedName = event.message;
    const updateDataNode = function (treeData, updatedName, id) {
      for (let i = treeData.length - 1; i >= 0; i--) {
        let treeNode = treeData[i];
        if (treeNode.id === id) {
          treeNode.name = updatedName;
          return;
        } else {
          if (treeNode.activities && treeNode.activities.length) {
            updateDataNode(treeNode.activities, updatedName, id);
          }
        }
      }
    }
    updateDataNode(treeData, updatedName, data.id);
    this.setState({
      updateTime: new Date()
    })
  }



  render() {

    let components = [];
    const thisObject = this;
    const getDataNode = function (treeData, container) {
      treeData.forEach(function (treeNode) {
        const dataNode = {
          label: <MenuNode label={treeNode.name} id={treeNode.id} handleAdd={thisObject.handleAdd}
            handleDelete={thisObject.handleDelete} dataChanged={thisObject.dataChanged}
            handleDnD={thisObject.treeDnDAction}
            handlePeer={thisObject.handlePeer} />
        }
        if (treeNode.activities && treeNode.activities.length) {
          dataNode.nodes = [];
          getDataNode(treeNode.activities, dataNode.nodes)
        }
        container.push(dataNode);
      });
    }

    getDataNode(treeData, components);


    return (
      <div>
        <TreeView
          className={`designerTree`}
          dataSource={components}
          enableSelection={true}
          enableHoverStyle={false}
          singleSelect={true}
          enableScrollNodeIntoView={false}
          onSelectionChange={(selectedMap) => {
            this.onSelectionChange(selectedMap);
          }}
          enableKeyboardNavigation={false}
          defaultCollapsed={{
            '0/0/1': true,
            '0/1': true,
            '0/2': true,
            '0/3': true
          }}
        />
      </div>
    );
  }
}

export default IntegrationTree;
